import { useEffect } from "react";

export default function JsonLd({ id, data }) {
  const json = JSON.stringify(data);
  useEffect(() => {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = json;
    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, json]);
  return null;
}
